export function resolveComponentVariant(component, value, allowed, fallback) {
  if (allowed.includes(value)) return value

  if (import.meta.env.DEV) {
    console.error(
      `[Wager Studio] Unsupported ${component} value "${String(value)}". `
      + `Expected one of: ${allowed.join(', ')}. Falling back to "${fallback}".`,
    )
  }

  return fallback
}

export function requireAccessibleName(component, value) {
  if (value) return value

  if (import.meta.env.DEV) {
    console.error(`[Wager Studio] ${component} requires an accessible name.`)
  }

  return 'Unnamed action'
}
